import React, { useEffect, useState, useRef } from "react";
import FourDThreeDTwoD from "./FourDThreeDTwoD/FourDThreeDTwoD";
import BalakBalikTab2 from "./BalakBalik/BalakBalikTab2";
import PolaTarung from "./PolaTarung/PolaTarung";
import QuickBuy from "./QuickBuy/QuickBuy";
import Bbfs from "./Bbfs/Bbfs";
import { useDispatch, useSelector } from "react-redux";
import BalakBalikVersiWap from "./BalakBalik/BalakBalikVersiWap";
import {
  set4dGameSubChildtype,
  set4dGameSubtype,
  setCommonConfig,
  setCurrentStep,
} from "../../../../redux/actions.js";
import VersiWAP from "../../MobileDesign/FourDMo/Versi_WAPP_mo/Versi_WAP_mo.js";
import TwoDDepan from "./TwoDDepan/TwoDDepan.js";
import ThreeDDepan from "./ThreeDDepan/ThreeDDepan.js";
import TwoDTengah from "./TwoDTengah/TwoDTengah.js";
import MarketClose from "../../SubComponents/MarketClose.js";
import ZeroBalancePopup from "../ZeroBalancePopup";
import GameClosedPopup from "../GameClosedPopup";
import leftArrow from "../../../../assets/images/Icons/left_arrow.svg";
import rightArrow from "../../../../assets/images/Icons/right_arrow.svg";
import { withTranslation } from "react-i18next";
import BolakBalikMain from "./BalakBalik/BolakBalikMain.js";
import { MdKeyboardArrowRight } from "react-icons/md";
import { TbBulb } from "react-icons/tb";
import CoachMarkPopup from "../../../Popups/CoachMarkPopup.js";
import DummyCoachMark from "../../../Popups/DummyCoachMark.js";

const FourDGame = (props) => {
  // const {coachText, coachStep}= props;
  const dispatch = useDispatch();
  const app_type = useSelector((state) => state.CommonConfig.app_type);
  const device = useSelector((state) => state.CommonConfig.device_type);
  const gameId = useSelector((state) => state.CommonConfig.gameId);
  const game_sub_type = useSelector((state) => state.GameSubType.game_sub_type);
  const marketStatus = useSelector((state) => state.CommonConfig.discount);
  const quickbuyStatus = useSelector((state) => state.CommonConfig.discount);
  const currentStep = useSelector((state) => state.paginationData.currentStep);

  const [activeTab, setActiveTab] = useState("4D3D2D");
  const [showArrow, setShowArrow] = useState(false);
  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(false);
  const subGameOnOffStatus = useSelector(
    (state) => state.CommonConfig.subGameOnOffStatus
  );
  const marketCloseStatus = useSelector(
    (state) => state.CommonConfig.marketCloseStatus
  );
  const user_balance = useSelector((state) => state.UserBalance.user_balance);
  const tabsElement = useRef(null);

  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
    dispatch(set4dGameSubtype({ key: "game_sub_type", value: tabIndex }));
    dispatch(
      set4dGameSubChildtype({
        key: "game_sub_child_type",
        value:
          tabIndex == "1"
            ? "DISCOUNT"
            : tabIndex == "2"
              ? "FULLBET"
              : tabIndex == "3"
                ? "PRIZE"
                : "",
      })
    );
    dispatch(setCommonConfig({ key: "clickTab", value: 1 }));
  };

  useEffect(() => {
    setActiveTab("4D3D2D");
    dispatch(set4dGameSubtype({ key: "game_sub_type", value: "4D3D2D" }));
    dispatch(
      set4dGameSubChildtype({ key: "game_sub_child_type", value: "DISCOUNT" })
    );
  }, []);

  // useEffect(() => {
  //   setActiveTab("4D3D2D")
  //   dispatch(set4dGameSubtype({ key: "game_sub_type", value: "4D3D2D" }));
  //   dispatch(set4dGameSubChildtype({ key: "game_sub_child_type", value: "DISCOUNT" }));
  // }, [app_type])

  const isHorizontalScroll = (element) => {
    return element.scrollWidth > element.clientWidth;
  };
  useEffect(() => {
    const element = tabsElement.current;
    if (element && isHorizontalScroll(element)) {
      setShowArrow(true);
    } else {
      setShowArrow(false);
    }
  }, [isHorizontalScroll]);
  const updateArrowsVisibility = () => {
    const element = tabsElement.current;
    if (element) {
      setShowLeftArrow(element.scrollLeft > 0);
      setShowRightArrow(
        element.scrollLeft < element.scrollWidth - element.clientWidth
      );
    }
  };

  useEffect(() => {
    const element = tabsElement.current;
    if (element && showArrow) {
      updateArrowsVisibility();
    }
  }, [activeTab, showArrow]);

  const scrollTabs = (direction) => {
    const element = tabsElement.current;
    if (element) {
      const childWidth = element.firstChild.clientWidth;
      const scrollAmount = childWidth; // Adjust the scroll amount as needed
      if (direction === "left") {
        element.scrollBy({ left: -scrollAmount, behavior: "smooth" });
      } else if (direction === "right") {
        element.scrollBy({ left: scrollAmount, behavior: "smooth" });
      }
    }
  };

  return (
    <div className="fourd-wrapper">
      <div style={{ isolation: "isolate" }} className={`custom-tooltip-wrapper ${currentStep === 1 ? "highlighted" : ""}`}>
        {showArrow && (
          <>
            {showLeftArrow && (
              <div className="arrow_btns">
                <div
                  className="arrow_btn left_arrow_btn"
                  onClick={() => scrollTabs("left")}
                >
                  <img src={leftArrow} alt="Left Arrow" />
                </div>
              </div>
            )}
            {showRightArrow && (
              <div className="arrow_btns">
                <div
                  className="arrow_btn right_arrow_btn"
                  onClick={() => scrollTabs("right")}
                >
                  <img src={rightArrow} alt="Right Arrow" />
                </div>
              </div>
            )}
          </>
        )}
        <div
          // className="navigational-tabwrapper"
          className={`navigational-tabwrapper ${currentStep === 1 ? "disabled" : ""
            }`}
          ref={tabsElement}
          onScroll={updateArrowsVisibility}
        >
          {device == "Desktop" ? (
            <div
              className={`tab custom-tooltip-wrapper ${activeTab === "4D3D2D" ? "active" : ""
                } ${currentStep === 1 ? "highlighted" : ""} `}
              onClick={() => handleTabClick("4D3D2D")}
            >
              4D/3D/2D
            </div>

          ) : null}
          {/* {(device == "Desktop" && app_type == "wap") && <div
            className={`tab ${activeTab === "BALAK-BALIK" ? "active" : ""}`}
            onClick={() => handleTabClick("BALAK-BALIK")}
          >
            BOLAK BALIK
          </div>
          } */}
          {device == "Desktop" ? (
            <div
              className={`tab custom-tooltip-wrapper ${activeTab === "BBFS" ? "active" : ""
                }`}
              onClick={() => handleTabClick("BBFS")}
            >
              BBFS
              <div className="custom-tooltip">
                <div className="quick-tip">
                  <TbBulb />
                  <span>Quick tip 3/11</span>
                </div>
                <div className="text">Switching to Sub-Games Tab</div>
                <p className="market-bet">Switch between tabs to choose your preferred bet type.</p>
                <div className="custom-action">
                  <div className="custom-bet">SKIP ALL</div>
                  <div className="custom-bet">
                    NEXT
                    <div className="right-arr">
                      <MdKeyboardArrowRight />
                    </div>
                  </div>
                </div>

                <span className="custom-tooltip-arrow"></span>
              </div>
            </div>
          ) : null}
          {device == "Desktop" ? (
            <div
              className={`tab custom-tooltip-wrapper ${activeTab === "POLA_TARUNG" ? "active" : ""}`}
              onClick={() => handleTabClick("POLA_TARUNG")}
            >
              POLA TARUNG
              <div className="custom-tooltip">
                <div className="quick-tip">
                  <TbBulb />
                  <span>Quick tip 4/11</span>
                </div>
                <div className="text">Switching to Sub-Games Tab</div>
                <p className="market-bet">Switch between tabs to choose your preferred bet type.</p>
                <div className="custom-action">
                  <div className="custom-bet">SKIP ALL</div>
                  <div className="custom-bet">
                    NEXT
                    <div className="right-arr">
                      <MdKeyboardArrowRight />
                    </div>
                  </div>
                </div>

                <span className="custom-tooltip-arrow"></span>
              </div>
            </div>
          ) : null}
        </div>
      </div>

      <div className="tabcontent-wrapper">
        {activeTab === "4D3D2D" && (
          <div>
            <FourDThreeDTwoD />
          </div>
        )}

        {activeTab === "BALAK-BALIK" && (
          // (marketStatus.subGameStatus == 0 || subGameOnOffStatus == 0) ? <GameClosedPopup /> : ((marketStatus.marketStatus == 0 || marketCloseStatus == 0) ? <MarketClose /> :
          // <div>
          //   {
          //     device === "Mobile" ? (
          //       <>
          //         <VersiWAP />
          //         {/* --- Rules ---  */}
          //         <div className='rules_container'>
          //           <div>
          //             <p>{props.t('guess_exact_number')}</p>
          //             <p>Format Tarun: nomar1*nomar2*nomar3#bet+
          //               namor1*namor2#bet</p>
          //             <p>Conoth Penulisan: 123*1234*12#5000+11*222*333
          //               #1000+33*777#2000</p>
          //           </div>
          //           <div className='rules_conversion'>
          //             <p>Konversi <br /> 1 = 1,000</p>
          //           </div>
          //         </div>
          //       </>
          //     ) : null
          //   }
          //   <BalakBalikVersiWap />

          // </div>
          <div>
            <BolakBalikMain />
          </div>
          // )
        )}

        {activeTab === "BBFS" && (
          <div>
            <Bbfs />
          </div>
        )}
        {activeTab === "POLA_TARUNG" && (
          <p>
            <PolaTarung />
          </p>
        )}
      </div>

      {/* {currentStep == 1 && <DummyCoachMark />} */}
      {currentStep == 1 && <CoachMarkPopup />}

    </div>
  );
};

export default withTranslation()(FourDGame);
